<template>
    <div class="context" v-loading="show_view_loading" :element-loading-text="loading_text"
         element-loading-spinner="el-icon-warning" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <div class="form">
                <el-form :model="patientForm" size="small" class="not_bottom_form" label-width="150px">
                    <div class="msg_title">基本信息</div>
                    <el-form-item label="患者姓名">
                        <span>{{ patientForm.patient_name }}</span>
                    </el-form-item>
                    <el-form-item label="性别">
                        <span v-if="patientForm.sex == 1">男</span>
                        <span v-else>女</span>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <span>{{ patientForm.phone }}</span>
                    </el-form-item>
                    <el-form-item label="就诊医院">
                        <span>{{ patientForm.hospital }}</span>
                    </el-form-item>
                    <el-form-item label="就诊城市">
                        <span>{{ patientForm.province }}/{{ patientForm.city }}</span>
                    </el-form-item>
                    <el-form-item label="就诊医生">
                        <span>{{ patientForm.doctor_name }}</span>
                    </el-form-item>
                    <el-form-item label="就诊科室">
                        <span>{{ patientForm.department }}</span>
                    </el-form-item>
                    <el-form-item label="上报日期">
                        <span>{{ patientForm.submit_date }}</span>
                    </el-form-item>
                    <el-form-item label="癌种">
                        <span>{{ patientForm.tumour }}</span>

                    </el-form-item>
                    <el-form-item label="分期（选填）">
                        <span>{{ patientForm.stage }}</span>
                    </el-form-item>
                    <el-form-item label="治疗线数">
                        <span>{{ patientForm.line_number }}</span>
                    </el-form-item>
                    <el-form-item label="治疗方案">
                        <span>{{ patientForm.schedule }}</span>
                    </el-form-item>
                    <div class="msg_title">用药信息</div>
                    <el-form-item label="使用药物">
                        <span>{{ showDrugName(patientForm.drug_code) }}</span>
                    </el-form-item>
                    <el-form-item label="购药记录">
                    </el-form-item>
                    <div>
                        <el-table :data="patientForm.medications" stripe>
                            <el-table-column label="周期" prop="medication_cycle_web" width="60"></el-table-column>
                            <el-table-column label="日期" prop="cycle_date" show-overflow-tooltip></el-table-column>
                            <el-table-column label="支数" prop="medication_count" width="60"></el-table-column>
                            <el-table-column label="类别" prop="medication_type"></el-table-column>
                        </el-table>
                    </div>
                    <el-form-item label="是否脱落">
                        <span v-if="patientForm.is_lose == 1">否</span>
                        <span v-else>是</span>
                    </el-form-item>
                    <el-form-item label="脱落原因" v-if="patientForm.is_lose == 2">
                        <span>{{ patientForm.lose_reason1 }}</span>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form form_right">
                <div class="msg_title has_btn_title">
                    <span>
                        {{ patientForm.patient_name }}，{{ patientForm.phone }}
                        <span class="phone_verify_result">{{patientForm.phone_false == 1 ? '(低风险)' : patientForm.phone_false == 2 ? '(高风险)' :''}}</span>
                    </span>
                    <span class="btn" @click="copyPhone()">复制</span>

                    <!-- <span class="status_text" v-if="is_finish == 2">随访已完成</span> -->
                    <div class="tabs" ref="tabList" @mousewheel="mousewheel">
                        <div
                                v-for="(item, index) in allTaskData"
                                :key="item.task_id"
                                class="tab_"
                                :class="activeTaskId == item.task_id ? 'active_tab' : ''"
                                @click="activeTab(item)"
                        >
                            {{allTaskData.length - index}}
                            <span>{{item | statusTitleFilter(self_)}}</span>
                        </div>
                    </div>
                </div>
                <el-form :model="taskForm"
                         ref="drug_form"
                         class="el_form_box"
                         size="normal"
                         label-width="150px"
                         :disabled="disabled"
                         :rules="rules">
                    <!-- <div class="msg_title has_btn_title">
                        <span>{{ patientForm.patient_name }}，{{ patientForm.phone }}</span>
                        <span class="btn" @click="copyPhone()">复制</span>

                        <span class="status_text" v-if="disabled">随访已完成</span>
                    </div> -->
                    <div v-if="source == 1">
                        <el-form-item label="验证结果：">
                            <el-radio-group v-model="taskForm.phone_is_real" @change="phone_is_realChange">
                                <el-radio :label="1">真实</el-radio>
                                <el-radio :label="2">存疑</el-radio>
                                <el-radio :label="3">本次未接听</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="验证病种："
                                      v-if="taskForm.phone_is_real != 3"
                        >
                            <!--
                            <el-radio-group v-model="taskForm.tumor_is_consistent"
                                            @change="changeTumorIsConsistent"
                            >
                                <el-radio :label="2">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                                <el-radio :label="3">未知</el-radio>
                            </el-radio-group>
                            v-if="taskForm.tumor_is_consistent == 1"
                           style="margin-left: 30px"
                            -->
                            <el-select v-model="taskForm.tumour_type"
                                       placeholder="请选择癌种"

                            >
                                <el-option v-for="(item, index) in tumour_type_list_by_drug"
                                           :key="index"
                                           :label="item"
                                           :value="item"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <div v-if="taskForm.phone_is_real == 2">
                            <el-form-item label="存疑原因：">
                                <el-select
                                        v-model="taskForm.skeptical"
                                        class="width_300"
                                        placeholder="请选择存疑原因"
                                >
                                    <el-option v-for="item in visit_skeptical" :key="item.value" :label="item.name"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <el-input
                                        type="textarea"
                                        style="width:350px;"
                                        :autosize="{ minRows: 2, maxRows: 3}"
                                        placeholder="请输入备注内容"
                                        v-model="taskForm.remark">
                                </el-input>
                            </el-form-item>
                        </div>

                        <div v-if="image_list && image_list.length > 0">
                            <el-form-item label="系统校验信息是否一致："
                                          label-width="200px"
                            >
                                <el-radio-group v-model="taskForm.verify_is_consistent">
                                    <el-radio :label="2">是</el-radio>
                                    <el-radio :label="1">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <div class="img_box">
                                    <el-image class="show_img"
                                              fit="cover"
                                              :src="show_image_url"
                                              :preview-src-list="image_list">
                                    </el-image>
                                    <i v-show="image_list.length > 1"
                                       @click="changeShowImg('last', image_list, 'show_image_url')"
                                       class="el-icon-back icon_btn left_btn"></i>
                                    <i v-show="image_list.length > 1"
                                       @click="changeShowImg('next', image_list, 'show_image_url')"
                                       class="el-icon-right icon_btn right_btn"></i>
                                </div>
                                <!--
                                <el-image style="width: 200px; height: 200px"
                                          :src="show_image_url"
                                          :preview-src-list="image_list">
                                </el-image>-->
                            </el-form-item>
                        </div>
                    </div>

                    <div v-if="source !== 1">
                        <el-form-item label="关注问题：">
                            <el-checkbox-group v-model="careList"
                                               @change="changeCare">
                                <el-checkbox label="疗效"></el-checkbox>
                                <el-checkbox label="经济"></el-checkbox>
                                <el-checkbox label="安全"></el-checkbox>
                                <el-checkbox label="便利"></el-checkbox>
                                <el-checkbox label="可及"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <div v-if="!disabled">
                            <el-form-item label="跟进情况：">
                                <el-radio-group v-model="taskForm.medication_status"
                                                @change="changeStatus">
                                    <el-radio v-for="item in medication_statusList"
                                              :label="item.value"
                                              :key="item.value"
                                    >{{item.name}}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <div v-if="taskForm.medication_status == 1">
                                <el-form-item label="用药疗程天数：">
                                    <el-input-number v-model="taskForm.medication_cycle_days" :min="1"
                                                     controls-position="right" @change="calculateNextVisitDate">
                                    </el-input-number>
                                </el-form-item>
                                <el-form-item label="下次随访日期：">
                                    <el-date-picker v-model="taskForm.next_visit_date" value-format="yyyy-MM-dd"
                                                    type="date"
                                                    :picker-options="getPickerOption1" placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 2">
                                <el-form-item label="购药记录：">
                                    <div v-for="(item, index) in taskForm.medications" class="drug_log_box"
                                         :key="index">
                                        <div class="input_span">
                                            <el-date-picker v-model="item.cycle_date" class="width_200"
                                                            value-format="yyyy-MM-dd" type="date"
                                                            :picker-options="getPickerOption2"
                                                            placeholder="选择日期"
                                                            @change="change_count">
                                            </el-date-picker>
                                        </div>
                                        <div class="input_span">
                                            <el-input-number v-model="item.medication_count" :min="1"
                                                             @change="change_count"
                                                             placeholder="支数" controls-position="right">
                                            </el-input-number>
                                        </div>
                                        <div class="input_span">
                                            <el-select v-model="item.medication_type" placeholder="请选择类别"
                                                       class="width_150">
                                                <el-option v-for="(items, indexs) in medication_type_list"
                                                           :label="items"
                                                           :value="items" :key="indexs">
                                                </el-option>
                                            </el-select>
                                        </div>

                                        <div class="icon_span" v-show="!item.medication_id" @click="delDrug(index)">
                                            <i class="el-icon-remove-outline table_del_btn"></i>
                                        </div>
                                        <div class="icon_span" v-if="index == taskForm.medications.length - 1"
                                             @click="addDrug()">
                                            <i class="el-icon-circle-plus-outline"></i>
                                        </div>

                                    </div>
                                </el-form-item>
                                <el-form-item label="用药疗程天数：">
                                    <el-input-number v-model="taskForm.medication_cycle_days" :min="1"
                                                     @change="change_count" controls-position="right"></el-input-number>
                                </el-form-item>
                                <el-form-item label="下次购药日期：">
                                    <el-date-picker v-model="taskForm.next_medication_date" value-format="yyyy-MM-dd"
                                                    type="date" :picker-options="getPickerOption1" placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 3">
                                <el-form-item label="脱落类别：">
                                    <el-radio-group v-model="taskForm.is_subjective_lose" @input="fallChange">
                                        <el-radio :label="1">客观脱落</el-radio>
                                        <el-radio :label="2">主观脱落</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="脱落原因：">
                                    <el-select v-model="taskForm.lose_reason1" class="width_300" @change="changeLose"
                                               placeholder="请选择脱落原因">
                                        <el-option
                                                v-for="item in taskForm.is_subjective_lose == 2 ? lose_reason_list2.subjective : taskForm.is_subjective_lose == 1 ? lose_reason_list2.objective : []"
                                                :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="taskForm.lose_reason1 && taskForm.lose_reason1 == '其他'">
                                    <el-input v-model="taskForm.lose_reason2" placeholder="请输入脱落原因" type="textarea"
                                              :autosize="{ minRows: 2, maxRows: 4 }" class="width_300"></el-input>
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 4" style="color:red;">
                                <el-form-item label="">
                                    正在开发...
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 5">
                                <el-form-item>
                                    <el-checkbox v-model="taskForm.is_next_visit" style="margin-right:10px;">择日再次随访
                                    </el-checkbox>
                                    <el-date-picker :disabled="!taskForm.is_next_visit"
                                                    v-model="taskForm.next_visit_date"
                                                    value-format="yyyy-MM-dd"
                                                    type="date" :picker-options="getPickerOption1"
                                                    placeholder="选择择日再次随访日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 6">
                                <el-form-item label="存疑原因：">
                                    <el-select v-model="taskForm.skeptical" class="width_300"
                                               placeholder="请选择存疑原因">
                                        <el-option v-for="item in visit_skeptical" :key="item.value" :label="item.name"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>

                        <div v-if="disabled" class="finish_form">
                            <el-form-item label="随访时间：">
                                <span>{{ taskForm.finish_time }}</span>
                            </el-form-item>
                            <el-form-item label="随访结果：">
                                <div>{{ taskForm.medication_status | filter_task_status }}</div>
                            </el-form-item>
                            <div v-if="taskForm.medication_status == 1">
                                <el-form-item label="用药疗程天数：">
                                    <span>{{ taskForm.medication_cycle_days }}</span>
                                </el-form-item>
                                <el-form-item label="下次随访日期：">
                                    <span>{{ taskForm.next_visit_date }}</span>
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 2">
                                <el-form-item label="购药记录：">
                                    <el-table :data="taskForm.medications" style="width: 400px" stripe>
                                        <el-table-column label="日期" prop="cycle_date"></el-table-column>
                                        <el-table-column label="支数" prop="medication_count"></el-table-column>
                                        <el-table-column label="类别" prop="medication_type"></el-table-column>
                                    </el-table>
                                </el-form-item>
                                <el-form-item label="用药疗程天数：">
                                    <span>{{ taskForm.medication_cycle_days }}</span>
                                </el-form-item>
                                <el-form-item label="下次购药日期：">
                                    <span>{{ taskForm.next_medication_date }}</span>
                                </el-form-item>
                            </div>
                            <div v-if="taskForm.medication_status == 3">
                                <el-form-item label="脱落原因：">
                                    <span v-if="taskForm.lose_reason1 != '其他'">{{ taskForm.lose_reason1 }}</span>
                                    <span v-else>{{ taskForm.lose_reason2 }}</span>
                                </el-form-item>
                            </div>
                        </div>

                        <div v-if="taskForm.medication_status != 4">
                            <el-form-item label="验证病种：">
                                <!--
                                <el-radio-group v-model="taskForm.tumor_is_consistent"
                                                @change="changeTumorIsConsistent"
                                >
                                    <el-radio :label="2">是</el-radio>
                                    <el-radio :label="1">否</el-radio>
                                    <el-radio :label="3">未知</el-radio>
                                </el-radio-group>
                                v-if="taskForm.tumor_is_consistent == 1"
                               style="margin-left: 30px"
                                -->
                                <el-select v-model="taskForm.tumour_type"
                                           placeholder="请选择癌种"

                                >
                                    <el-option v-for="(item, index) in tumour_type_list_by_drug"
                                               :key="index"
                                               :label="item"
                                               :value="item"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <el-input
                                        type="textarea"
                                        v-if="!disabled"
                                        :disabled="disabled"
                                        style="width:350px;"
                                        :autosize="{ minRows: 2, maxRows: 3}"
                                        placeholder="请输入备注内容"
                                        v-model="taskForm.remark">
                                </el-input>
                                <div v-else>{{taskForm.remark}}</div>
                            </el-form-item>
                        </div>

                        <div v-if="showInfo && !disabled" style="color:red;">
                            <el-form-item label="">
                                {{infoText}}
                            </el-form-item>
                        </div>
                    </div>

                    <el-table
                            v-if="false && old_task_datas.length > 0"
                            :data="old_task_datas"
                            size="small"
                            style="width: 100%">
                        <el-table-column
                                prop="create_time"
                                label="创建时间"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="finish_time"
                                label="完成时间"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="source_str"
                                label="来源">
                        </el-table-column>
                        <el-table-column
                                prop="visit_result"
                                label="随访结果">
                        </el-table-column>
                    </el-table>
                </el-form>

                <div class="btn_box" v-if="!disabled">
                    <div>
                        <el-button @click="lastRow">上一个</el-button>
                        <el-button
                                v-if="!cutSubmitButton"
                                @click="submit_audit('finish')"
                                type="primary"
                        >
                            {{confirmText}}
                        </el-button>
                        <el-popover
                                v-if="cutSubmitButton"
                                placement="top"
                                width="160"
                                style="margin: 0 10px;"
                                v-model="visible">
                            <p>请核对购药支数是否正确填写, 是否继续？</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                                <el-button type="primary" size="mini" @click="submit_audit('finish')">确定</el-button>
                            </div>
                            <el-button slot="reference" type="primary">{{confirmText}}</el-button>
                        </el-popover>
                        <el-button @click="nextRow">下一个</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {clone, lcGet, formatTime} from "@/global/utils";
    import {getImageUrl} from "@/api/index";
    import imgView from "../common/imgView"
    import {calc_times, calc_times_2} from "@/global/calc_drug"

    const self = this;
    export default {
        name: "auditView",
        components: {
            imgView
        },
        data() {
            return {
                self_: this,
                is_finish: 0,
                source: '',
                confirmText: '完成随访',
                showInfo: false,
                infoText: "在疗程内已有购药记录，无法保存。",
                visible: false,
                cutSubmitButton: false,
                patientForm: {},
                taskForm: {
                    care_about: {
                        care_about_effect: 0,
                        care_about_economy: 0,
                        care_about_convenient: 0,
                        care_about_safety: 0,
                        care_about_accessibility: 0,
                    }, // 治疗偏好
                    medication_status: '2',

                    next_visit_date: '',
                    medication_cycle_days: 21,

                    medications: [
                        {cycle_date: '', medication_count: 0, medication_type: '', sub_count1: 0, sub_count2: 0},
                    ],
                    is_subjective_lose: '',
                    // tumor_is_consistent: '',
                    tumour_type: '',
                    next_medication_date: '',
                    remark: "", //备注
                    skeptical: '',

                    lose_reason1: '',
                    lose_reason2: '',
                },
                old_task_datas: [], //历史任务列表
                activeTaskId: '',
                allTaskData: [], //所有任务列表 old_task_datas + task_data
                careList: [],// 治疗偏好

                last_medication_cycle_days: '',
                rules: {
                    // next_visit_date: [{ required: true, message: '请选择下次随访时间', trigger: 'blur' }],
                    // medication_status: [{ required: true, message: '请选择跟进情况', trigger: 'blur' }],
                    // medication_cycle_days: [{ required: true, message: '请选择用药疗程天数', trigger: 'blur' }],

                },
                viewTitle: '',
                disabled: false,

                getPickerOption1: {
                    disabledDate(time) {
                        return new Date(time).getTime() < (new Date().getTime() - 3600 * 1000 * 24)
                    }
                },
                getPickerOption2: {
                    disabledDate(time) {
                        return new Date(time).getTime() > new Date().getTime()
                    }
                },

                type_list: [],

                task_id: null,


                // 锁定参数
                lock_time: 200,
                time_inter: null,
                show_view_loading: false,
                is_lock: false,
                is_requesting: false,

                // 药物配置项
                drug_type_list: [],
                cycle_days: 21,
                cycle_medication_count: 2,
                cycle_type: 'count',

                drug_code_list: [],
                select_drug_conf: {},

                show_image_url: null,
                image_list: null,
            }
        },
        computed: {
            ...mapState('illuserData', {
                audit_visit_id: 'audit_visit_id',
                audit_ill_ids: 'audit_visit_ids'
            }),
            ...mapState("comInformationData", {
                authority: 'authority',
                allIllData: 'allIllData',
                // drug_code_list: 'drug_code_list',
                medication_type_list: "medication_type_list",
                medication_statusList: "medication_statusList",

                stage_list: 'stage_list',
                line_number_list: 'line_number_list',
                department_list: 'department_list',
                schedule_list: 'schedule_list',
                tumour_list: 'tumour_list',
                tumour_type_list: 'tumour_type_list',
                lose_reason_list: 'lose_reason_list',
                lose_reason_list2: 'lose_reason_list2',
                visit_skeptical: 'visit_skeptical',
            }),
            powerAudit() {
                return this.authority.indexOf('visit-audit-pass') > -1
            },
            powerRefuse() {
                return this.authority.indexOf('visit-audit-refuse') > -1
            },
            powerDel() {
                return this.authority.indexOf('visit-audit-del') > -1
            },

            loading_text() {
                return `还有${this.lock_time}秒将自动解锁！`
            },

            tumour_type_list_by_drug() {
                let code = this.patientForm.drug_code;
                let list = this.tumour_type_list[code];
                if(list && list.length > 0) {
                    return list
                }
                return []
            },
        },
        filters: {
            showStatus(val) {
                return val == '1' ? '未完成' :
                    val == '2' ? '已完成' :
                        val == '3' ? '随访中' :
                            ''
            },
            statusTitleFilter(item, self_) {
                let is_finish = item.is_finish;
                if (is_finish == 2) {
                    let medication_status = item.medication_status;
                    let f = self_.medication_statusList.find(l => l.value == medication_status)
                    if (f) {
                        return `(${f.name})`
                    }

                } else if (is_finish == 1) {
                    return '(未完成)'
                }
            },

            filter_task_status(val) {
                return val == '1' ? '未购药' :
                    val == '2' ? '已购药' :
                        val == '3' ? '已脱落' :
                            ''
            }

        },
        mounted() {
            this.task_id = clone(this.audit_visit_id);
            // this.getIllForm(this.task_id);
            this.getDrugList()
        },
        beforeDestroy() {
            window.removeEventListener('mousemove', this.lockNow);
            if (this.time_inter) {
                clearInterval(this.time_inter);
            }

            if (this.is_lock) {
                this.unlockNow()
            }
        },
        methods: {
            getDrugList() {
                this.httpGet('/product/list').then(res => {
                    this.drug_code_list = res.data.data_list;

                    this.getIllForm(this.task_id);
                });
            },
            get_drug_conf() {
                let drug_code = this.patientForm.drug_code;
                let conf = this.drug_code_list.filter(res => res.drug_code === drug_code)[0];
                // console.log(conf, drug_code,this.drug_code_list, '615');
                this.select_drug_conf = conf;

                let names = ['drug_type_list', 'cycle_days', 'cycle_medication_count', 'cycle_type'];
                for (let i = 0; i < names.length; i++) {
                    if (conf && conf[names[i]]) {
                        this[names[i]] = conf[names[i]]
                    }
                }
            },

            changeShowImg(type, list, prop) {
                let index = list.indexOf(this[prop]);
                let length = list.length;
                if(type === 'last') {
                    if(index === 0) {
                        this.$message.warning('已经是第一张了');
                        return
                    }
                    this[prop] = list[index - 1]
                } else {
                    if(index === length - 1) {
                        this.$message.warning('已经是最后一张了');
                        return
                    }
                    this[prop] = list[index + 1]
                }
            },

            showDrugName(val) {
                let text = '';
                this.drug_code_list.forEach(v => {
                    if (val == v.drug_code) {
                        text = v.name
                    }
                });
                return text
            },
            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            copyPhone(val) {
                let phone = this.patientForm.phone;
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(phone);
                    this.$message.success('复制成功')
                }
            },
            mousewheel(e) {
                let v = -e.wheelDelta / 2;
                this.$refs.tabList.scrollLeft += v;
                e.preventDefault();
            },
            activeTab(item) {
                // console.log("item", item)
                this.taskForm = this.$options.data().taskForm;
                this.activeTaskId = item.task_id;
                this.viewTitle = `随访工单(${item.source_str})`;

                let is_finish = item.is_finish;
                this.is_finish = is_finish;
                this.confirmText = '完成随访';

                let base_form = {
                    care_about: {
                        care_about_effect: 0,
                        care_about_economy: 0,
                        care_about_convenient: 0,
                        care_about_safety: 0,
                        care_about_accessibility: 0,
                    }, // 治疗偏好
                    medication_status: '2',

                    next_visit_date: '',
                    medication_cycle_days: 21,

                    medications: [
                        {cycle_date: '', medication_count: 0, medication_type: '', sub_count1: 0, sub_count2: 0},
                    ],
                    is_subjective_lose: '',
                    // tumor_is_consistent: '',
                    tumour_type: '',
                    next_medication_date: '',
                    remark: "", //备注
                    skeptical: '',

                    lose_reason1: '',
                    lose_reason2: '',
                };
                this.taskForm = item.visit_result || base_form;
                this.updateTimeStatus();//查询是否在14天内有多个购药记录
                this.taskForm.finish_time = item.finish_time || '';
                this.setCare(this.taskForm.care_about);
                if (is_finish == 2) {
                    this.confirmText = '再次保存';
                }
                // console.log(this.taskForm)
            },

            setKeyUp() {
                // 监听操作
                window.addEventListener('mousemove', this.lockNow);
            },
            setLockInter() {
                this.time_inter = setInterval(() => {
                    this.lock_time--;
                    this.show_view_loading = this.lock_time <= 60 && this.lock_time > 0;
                    if (this.lock_time <= 0) {
                        clearInterval(this.time_inter);
                        this.unlockNow();
                        this.$msgbox({
                            title: '警告',
                            message: '该数据已超时自动解锁，是否要继续随访？',
                            showCancelButton: true,
                            confirmButtonText: '继续随访当前',
                            cancelButtonText: '随访下一个',
                        }).then(() => {
                            this.lockNow()
                        }).catch(() => {
                            this.nextRow('del')
                        })
                    }
                }, 1000)
            },
            changeLockTime() {
                /**
                 * 待审核锁定，10分钟后自动解锁
                 * 操作的情况下5分钟重新锁定，重新计算时间
                 * 不操作，9分钟的时候进行提示，还不操作即锁定
                 */
                this.show_view_loading = false;
                this.lock_time = 590;
            },
            lockNow() {
                if (this.lock_time > 300) return; // 自动锁定时间不到一半的时候再通过
                if (this.is_requesting) return;
                this.is_requesting = true;
                let params = {
                    task_id: this.task_id
                };
                this.httpGet('/visit_task/lock', params).then(res => {
                    this.is_requesting = false;
                    if (res.data.success) {
                        this.is_lock = true;
                        this.changeLockTime();
                        if (this.time_inter) {
                            clearInterval(this.time_inter);
                        }
                        this.setLockInter();
                        console.log('锁定成功');
                    } else {
                        this.$message.warning('该条数据已被其他人锁定！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 10)
                    }
                })
            },
            unlockNow() {
                let params = {
                    task_id: this.task_id
                };
                this.httpGet('/visit_task/unlock', params).then(res => {
                    this.is_lock = false;
                    if (this.time_inter) {
                        clearInterval(this.time_inter);
                    }
                    this.lock_time = 200;
                    console.log('解锁成功');
                })
            },
            updateTimeStatus() {
                // 查询是否在14天内有多个购药记录
                let dateRange = 60 * 60 * 24 * 14 * 1000; //14天毫秒数
                let rightData = this.taskForm;
                let medications = this.patientForm.medications;
                this.showInfo = false;
                medications.forEach((item, index) => {
                    if (rightData.medications) {
                        rightData.medications.forEach(rItem => {
                            let r_time = new Date(rItem.cycle_date).getTime();
                            let l_time = new Date(item.cycle_date).getTime();
                            if (Math.abs(r_time - l_time) < dateRange && rItem.medication_count >= 2 && rItem.medication_id !== item.medication_id) {
                                this.showInfo = true;
                            }
                        })
                    }

                })
            },
            updateMedicationCountStatus() {
                //购药支数是否>=8 大于8切换带二次确认的按钮
                this.cutSubmitButton = false;
                this.taskForm.medications.forEach(med => {
                    if (med.medication_count >= 8) {
                        this.cutSubmitButton = true;
                    }
                })
            },

            getIllForm(id) {
                this.cutSubmitButton = false;
                this.httpGet(`/visit_task/${id}`).then(res => {
                    // console.log("清单....", res.data)
                    this.old_task_datas = res.data.old_task_datas;
                    this.patientForm = res.data.patient_data;
                    this.source = res.data.task_data.source;
                    let medications = this.patientForm.medications.reverse();
                    medications.forEach((item, index) => {
                        // 当前周期 = 上次的支数/2 + 上次的周期
                        if (index == 0) {
                            item.medication_cycle_web = 1;
                        }
                        let last_ = medications[index - 1];
                        if (last_) {
                            let num = Math.floor(last_.medication_count / 2);
                            if (last_.medication_count > 0 && num < 1) {
                                num = 1;
                            }
                            item.medication_cycle_web = last_.medication_cycle_web + num;
                        }

                    });
                    medications.reverse();
                    this.patientForm.phone = this.patientForm.phone == this.patientForm.user_id ? '' : this.patientForm.phone;
                    this.last_medication_cycle_days = this.patientForm.medication_cycle_days;

                    // this.viewTitle = '随访工单详情';
                    this.viewTitle = `随访工单(${res.data.task_data.source_str})`;

                    let is_finish = res.data.task_data.is_finish;
                    this.is_finish = is_finish;
                    this.confirmText = '完成随访';
                    if (is_finish == 1) {
                        this.disabled = false;
                        //    待审核的进入锁定状态
                        this.lockNow();
                        this.setKeyUp();
                        if (this.source == 1) {
                            //手机号验真
                            // 系统校验信息是否一致
                            let invoice_info_list = res.data.task_data.invoice_info_list || [];
                            this.image_list = invoice_info_list.map(v => v.file_url);
                            this.show_image_url = this.image_list[this.image_list.length - 1] || null;
                            let last_image_data = invoice_info_list[invoice_info_list.length - 1];
                            let same_name = '';
                            if(last_image_data) {
                                same_name = last_image_data.patient_name == this.patientForm.patient_name ?
                                    2 : 1
                            }

                            this.taskForm = {
                                phone_is_real: res.data.task_data.phone_is_real,
                                skeptical: res.data.task_data.skeptical,
                                remark: res.data.task_data.remark,
                                // tumor_is_consistent: res.data.task_data.tumor_is_consistent || '',
                                // tumour: res.data.task_data.tumour || '',
                                tumour_type: res.data.task_data.tumour_type || '',
                                verify_is_consistent: res.data.task_data.verify_is_consistent || same_name
                            }
                        } else {
                            this.updateTaskForm();
                            let care_about = res.data.patient_data.care_about;
                            this.setCare(care_about);
                        }
                    } else {
                        // this.disabled = true;
                        let base_form = {
                            care_about: {
                                care_about_effect: 0,
                                care_about_economy: 0,
                                care_about_convenient: 0,
                                care_about_safety: 0,
                                care_about_accessibility: 0,
                            }, // 治疗偏好
                            medication_status: '2',

                            next_visit_date: '',
                            medication_cycle_days: 21,

                            medications: [
                                {cycle_date: '', medication_count: 0, medication_type: ''},
                            ],
                            next_medication_date: '',

                            lose_reason1: '',
                            lose_reason2: '',

                            // tumor_is_consistent: res.data.task_data.tumor_is_consistent || '',
                            // tumour: res.data.task_data.tumour || '',
                            tumour_type: res.data.task_data.tumour_type || '',
                        };
                        this.taskForm = Object.assign(base_form, res.data.task_data.visit_result);
                        // this.taskForm.tumor_is_consistent = Number(this.taskForm.tumor_is_consistent);
                        this.updateTimeStatus();//查询是否在14天内有多个购药记录
                        this.taskForm.finish_time = res.data.task_data.finish_time || '';
                        if (this.source == 1) {
                            //手机号验真
                            // 系统校验信息是否一致
                            let invoice_info_list = res.data.task_data.invoice_info_list || [];
                            this.image_list = invoice_info_list.map(v => v.file_url);
                            this.show_image_url = this.image_list[this.image_list.length - 1] || null;
                            let last_image_data = invoice_info_list[invoice_info_list.length - 1];
                            let same_name = '';
                            if(last_image_data) {
                                same_name = last_image_data.patient_name == this.patientForm.patient_name ?
                                    2 : 1
                            }
                            this.taskForm = {
                                phone_is_real: res.data.task_data.phone_is_real,
                                skeptical: res.data.task_data.skeptical,
                                remark: res.data.task_data.remark,
                                // tumor_is_consistent: res.data.task_data.tumor_is_consistent || '',
                                // tumour: res.data.task_data.tumour || '',
                                tumour_type: res.data.task_data.tumour_type || '',
                                verify_is_consistent: res.data.task_data.verify_is_consistent || same_name
                            }
                        }
                        // console.log(this.taskForm, '844');
                        this.setCare(this.taskForm.care_about);
                    }
                    if (is_finish == 2) {
                        this.confirmText = '再次保存';
                        // if(res.data.task_data.visit_result && res.data.task_data.visit_result.medication_status == 2){
                        //     this.disabled = true;
                        // }
                    }
                    this.activeTaskId = res.data.task_data.task_id;
                    this.allTaskData = [res.data.task_data, ...res.data.old_task_datas];
                    // console.log("-------", this.taskForm);

                    this.get_drug_conf()
                })
            },
            lastRow() {
                let index = this.audit_ill_ids.findIndex(n => n == this.task_id);
                if (index > 0) {
                    let id = this.audit_ill_ids[index - 1];
                    this.task_id = clone(id);
                    this.getIllForm(id);
                    this.$message.success('已进入上一条');
                } else {
                    this.$message.warning('已经是第一条了');
                }
            },
            nextRow(type) {
                let index_ = -1;
                this.audit_ill_ids.forEach((v, i) => {
                    if (v == this.task_id) {
                        index_ = i
                    }
                });
                if (index_ === this.audit_ill_ids.length - 1) {
                    this.$message.warning('已经是最后一条了');
                    if (type && type === 'del') {
                        this.goBack()
                    } else {
                        this.getIllForm(this.task_id)
                    }

                } else {
                    this.unlockNow();
                    setTimeout(() => {
                        let id = this.audit_ill_ids[index_ + 1];
                        this.task_id = clone(id);
                        this.getIllForm(id);
                        this.$message.success('已进入下一条');
                    }, 0);
                }

            },

            submit_audit(type) {
                this.visible = false;
                if (this.taskForm.medication_status == 4) {
                    this.$message.warning('异地购药功能正在开发...');
                    return;
                }
                this.updateTimeStatus();
                if (this.showInfo) {
                    this.$message.warning(this.infoText);
                    return;
                }
                this.$refs.drug_form.validate(valid => {
                    if (valid) {
                        // console.log("-------valid", this.taskForm);
                        let bol = false;
                        if (this.taskForm.medication_status == 1) {
                            if (!this.taskForm.medication_cycle_days || !this.taskForm.next_visit_date) {
                                //用药疗程天数、下次随访日期
                                console.log("空。。。")
                                bol = true;
                            }
                        } else if (this.taskForm.medication_status == 2) {
                            if (!this.taskForm.next_medication_date || !this.taskForm.medication_cycle_days) {
                                //下次购药日期、用药疗程天数、
                                console.log("空。。。")
                                bol = true;
                            }
                            if (this.taskForm.medications.length < 0) {
                                console.log("空。。。")
                                bol = true;
                            } else {
                                //购药记录必须大于0，大于0后且必须有值
                                this.taskForm.medications.forEach(med => {
                                    Object.keys(med).forEach(key => {
                                        if (!med[key]) {
                                            console.log("空....")
                                            bol = true;
                                        }
                                    })
                                })
                            }
                        } else if (this.taskForm.medication_status == 3) {
                            if (!this.taskForm.is_subjective_lose) {
                                console.log("空。。。")
                                bol = true;
                            } else {
                                if (!this.taskForm.lose_reason1) {
                                    console.log("空。。。")
                                    bol = true;
                                }
                                if (this.taskForm.lose_reason1 == '其他') {
                                    if (!this.taskForm.lose_reason2) {
                                        console.log("空。。。")
                                        bol = true;
                                    }
                                }
                            }
                        } else if (this.taskForm.medication_status == 5) {
                            if (!this.taskForm.is_next_visit || !this.taskForm.next_visit_date) {
                                console.log("空。。。")
                                bol = true;
                            }
                        } else if (this.taskForm.medication_status == 6) {
                            if (!this.taskForm.skeptical) {
                                bol = true;
                            }
                        }
                        if (this.source == 1) {
                            if (!this.taskForm.phone_is_real) {
                                bol = true;
                            }
                            if (this.taskForm.phone_is_real == 2) {
                                if (!this.taskForm.skeptical) {
                                    bol = true;
                                } else {
                                    if (this.taskForm.skeptical == 6 && !this.taskForm.remark) {
                                        bol = true;
                                    }
                                }
                            }
                            if(this.taskForm.phone_is_real != 3) {
                                // 验证病种
                                if (!this.taskForm.tumour_type) {
                                    console.log("空。。。");
                                    bol = true;
                                }
                            }
                        } else {
                            // 验证病种 非验真
                            if(this.taskForm.medication_status != 4) {
                                // 非异地购药
                                if (!this.taskForm.tumour_type) {
                                    console.log("空。。。");
                                    bol = true;
                                }
                            }
                        }
                        // if (!this.taskForm.tumor_is_consistent) {
                        //     // 癌种是否一致验证
                        //     console.log("空。。。");
                        //     bol = true;
                        // } else if (this.taskForm.tumor_is_consistent == 1) {
                        //     // 癌种是否一致为否时， 验证是否填写新癌种
                        //     if (!this.taskForm.tumour_type) {
                        //         console.log("空。。。");
                        //         bol = true;
                        //     }
                        // }
                        if (bol) {
                            this.$message.warning('请完整填写信息...');
                            return;
                        }
                        let text = '已完成随访';
                        let params = {
                            ...this.taskForm,
                            patient_id: this.patientForm.patient_id,
                            // task_id: this.task_id,
                            task_id: this.activeTaskId,
                        };
                        // console.log(params, 'audit------');
                        this.httpPost('/visit_task/do_task2', params).then(res => {
                            this.cutSubmitButton = false;
                            this.$message.success(text);
                            setTimeout(() => {
                                this.nextRow()
                            }, 1000)
                        })
                    }
                })
            },
            submit_delete() {
                this.$confirm('确定删除该任务么？').then(res => {
                    this.httpDel(`/user/patient/${this.patientForm.patient_id}`).then(res => {
                        this.$message.success('删除成功！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 1000)
                    })
                })
            },
            phone_is_realChange() {
                if (this.taskForm.phone_is_real !== 2) {
                    this.taskForm.skeptical = '';
                    this.taskForm.remark = '';
                }
                if (this.taskForm.phone_is_real === 3) {
                    this.taskForm.tumour_type = '';
                }
            },

            updateTaskForm() {
                this.careList = [];
                this.taskForm.medication_status = '2';
                this.taskForm.remark = '';
                this.changeCare();
                this.changeStatus();
            },

            setCare(form) {
                if (!form) return;
                if (form.care_about_effect == 1) {
                    this.careList.push('疗效')
                }
                if (form.care_about_economy == 1) {
                    this.careList.push('经济')
                }
                if (form.care_about_convenient == 1) {
                    this.careList.push('便利')
                }
                if (form.care_about_safety == 1) {
                    this.careList.push('安全')
                }
                if (form.care_about_accessibility == 1) {
                    this.careList.push('可及')
                }
            },
            changeCare() {
                let list = this.careList, form = this.taskForm.care_about;
                if (form) {
                    form.care_about_effect = list.indexOf('疗效') > -1 ? 1 : 0;
                    form.care_about_economy = list.indexOf('经济') > -1 ? 1 : 0;
                    form.care_about_convenient = list.indexOf('便利') > -1 ? 1 : 0;
                    form.care_about_safety = list.indexOf('安全') > -1 ? 1 : 0;
                    form.care_about_accessibility = list.indexOf('可及') > -1 ? 1 : 0;
                }

                // console.log(this.taskForm, '515');
            },
            fallChange(e) {
                this.taskForm.lose_reason1 = '';
                this.taskForm.next_medication_date = '';
                this.$forceUpdate();
            },
            calculateNextVisitDate() {
                let data = this.patientForm.medications[0];
                if (data.cycle_date) {
                    let num = Math.floor(data.medication_count / 2);
                    if (data.medication_count > 0 && num < 1) {
                        num = 1;
                    }
                    const start = new Date(data.cycle_date);
                    start.setTime(start.getTime() + 3600 * 1000 * 24 * (this.taskForm.medication_cycle_days * num));
                    this.taskForm.next_visit_date = start.toJSON().split('T')[0];
                }
            },
            changeStatus() {
                this.taskForm.next_visit_date = '';
                this.taskForm.medication_cycle_days = Number(clone(this.last_medication_cycle_days));
                this.taskForm.is_subjective_lose = '';
                this.cutSubmitButton = false;

                let count = 1;
                if (this.taskForm.medication_status == 1) {
                    let data = this.patientForm.medications[0];
                    if (data.cycle_date) {
                        let num = Math.floor(data.medication_count / 2);
                        if (data.medication_count > 0 && num < 1) {
                            num = 1;
                        }
                        const start = new Date(data.cycle_date);
                        start.setTime(start.getTime() + 3600 * 1000 * 24 * (this.taskForm.medication_cycle_days * num));
                        this.taskForm.next_visit_date = start.toJSON().split('T')[0];
                    }

                }
                if (this.taskForm.medication_status == 2) {
                    count = 2;
                }
                if (this.taskForm.medication_status == 4) {
                    //异地购药
                    // count = 0;
                    // this.taskForm.medication_cycle_days = '';
                } else if (this.taskForm.medication_status == 3) {
                    this.taskForm.is_subjective_lose = 1; //is_subjective_lose是否主观脱落
                }

                this.taskForm.medications = [
                    {cycle_date: '', medication_count: count, medication_type: ''},
                ];

                this.taskForm.lose_reason1 = '';
                this.taskForm.lose_reason2 = '';
                this.$forceUpdate();
            },
            changeLose() {
                this.taskForm.lose_reason2 = ''
            },
            delDrug(index) {
                if (this.taskForm.medications.length < 2) return;
                this.taskForm.medications.splice(index, 1);
                this.changeNextDate()
            },
            addDrug() {
                let item = {
                    cycle_date: '',
                    medication_count: 1,
                    medication_type: ''
                };
                this.taskForm.medications.push(item);
            },
            change_count() {
                // console.log(this.taskForm.medications, '596');
                this.updateTimeStatus();
                this.updateMedicationCountStatus();
                this.changeNextDate()
            },
            changeNextDate() {
                let list = this.taskForm.medications;
                let latest_time = 0;
                let latest_num = 0, all_num = 0;

                list.forEach(v => {
                    let time = Date.parse(v.cycle_date);
                    if (time > latest_time) {
                        latest_time = time;
                        latest_num = v.medication_count
                    }
                    all_num = all_num + Number(v.medication_count);
                });
                if (!latest_num || latest_num == 0) return;
                let old_cycle = this.patientForm.medication_cycle;
                let d_count = this.cycle_medication_count;
                let d_days = this.cycle_days;
                let days = this.taskForm.medication_cycle_days;
                days = days && days != 0 ? Number(days) : d_days ? Number(d_days) : 21;

                // 计算下次购药日期
                let cycle_t = parseInt(Number(latest_num) / Number(d_count));
                cycle_t = cycle_t < 1 ? 1 : cycle_t;
                latest_time = latest_time + cycle_t * 3600 * 24 * 1000 * days;
                this.taskForm.next_medication_date = formatTime(new Date(latest_time)).time1;
                // 计算周期
                let cycle = parseInt(Number(all_num) / Number(d_count));
                this.taskForm.medication_cycle = Number(old_cycle) + cycle;
                // 计算总用药支数
                let old_count = this.patientForm.medication_count;
                this.taskForm.medication_count = Number(old_count) + all_num;
            },

            changeTumorIsConsistent() {
                // this.taskForm.tumour = ''
                this.taskForm.tumour_type = ''
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background: #fff;

        .header {
            height: 45px;
            line-height: 45px;

            display: flex;
            justify-content: space-between;
            padding: 0 20px;

            .search {
                padding-top: 15px;
            }
        }

        .main_box {
            display: flex;
            height: calc(100% - 50px);
            overflow: hidden;

            .form {
                flex: 1;
                height: 100%;
                overflow: hidden;
                overflow-y: auto;
                padding: 5px;
                box-sizing: border-box;

                .msg_title {
                    line-height: 35px;
                    font-size: .875rem;
                    padding: 0 20px;
                    background: rgb(233, 233, 235);
                    color: #606266;
                    margin-bottom: 5px;
                }

                .has_btn_title {
                    font-size: 1.25rem;
                    font-weight: 600;
                    display: flex;
                    .phone_verify_result {
                        font-size: 10px;
                        color: red;
                        font-weight: initial;
                    }

                    .btn {
                        padding: 0 20px;
                        margin-left: 20px;
                        color: #409EFF;
                        cursor: pointer;
                        font-size: .9rem;
                        font-weight: 500;
                    }

                    .status_text {
                        font-size: .9rem;
                        font-weight: 500;
                        color: #67C23A;
                        padding: 0 20px;
                    }
                    .tabs {
                        flex: 1;
                        overflow-y: hidden;
                        overflow-x: auto;
                        display: flex;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        .tab_ {
                            padding: 0 20px;
                            cursor: pointer;
                            white-space: nowrap;
                            span {
                                font-size: 10px;
                                font-weight: 100;
                            }
                        }
                        .active_tab {
                            background: white;
                            border-top: 1px solid #e9e9eb;
                        }
                    }
                }
            }

            .form_right {
                flex: 2;
                display: flex;
                flex-flow: column;

                .el_form_box {
                    flex: 1;
                    overflow-y: auto;

                    .img_box {
                        position: relative;
                        z-index: 1;
                        width: 250px;
                        .show_img {
                            width: 250px;
                            height: 250px;
                        }
                        .icon_btn {
                            position: absolute;
                            line-height: 25px;
                            width: 25px;
                            text-align: center;
                            background-color: rgba(255, 255, 255, .7);
                            z-index: 99;
                            display: none;
                            overflow: hidden;
                            border-radius: 50%;
                            cursor: pointer;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                        .left_btn {
                            left: 5px;
                        }
                        .right_btn {
                            right: 5px;
                        }
                        &:hover {
                            .icon_btn {
                                display: block;
                            }
                        }
                    }
                }

                .drug_log_box {
                    display: flex;

                    .input_span {
                        margin-right: 5px;
                    }

                    .icon_span {
                        padding: 0 10px;
                        font-size: 24px;
                        cursor: pointer;
                    }
                }

                .btn_box {
                    flex: 0 0 40px;
                    width: 100%;
                    text-align: center;
                    padding: 5px;
                    box-sizing: border-box;
                    background-color: #fafafa;
                }

                .finish_form {
                    .form_form_item {
                        position: relative;
                        left: -60px;
                    }
                }
            }
        }

    }
</style>